import { useContext } from "react";
import { Card, DatePicker, Form, Input, Select, Table } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  BALANCE_DEDUCTION_TYPE_CUSTOMERSMANAGEMENT,
  BALANCE_DEDUCTION_TYPE_JOBMANAGEMENT,
  BALANCE_DEDUCTION_TYPE_ORDERMANAGEMENT,
  BALANCE_DEDUCTION_TYPE_QRORDER,
  BALANCE_DEDUCTION_TYPE_SALESINVOICE,
  BALANCE_DEDUCTION_TYPE_STOCKMANAGEMENT,
  BALANCE_DEDUCTION_TYPE_SUBSCRIPTION,
  BALANCE_DEDUCTION_TYPE_SUREPAY,
  BALANCE_DEDUCTION_TYPE_TABLEMANAGEMENT,
  BALANCE_DEDUCTION_TYPE_TICKETING,
  BALANCE_DEDUCTION_TYPE_WAITERMANAGEMENT,
  deduction_types,
} from "../../../../configs/constants";
import CurrencyFormatter from "../../../../components/CurrencyFormatter";
import { AppContext } from "../../../../context/AppContextProvider";

const TransactionsTable = ({
  balanceDeductionsHistory,
  setSearchParams,
  paginationData,
  setPaginationData,
  setCurrentPage,
  setPerPageSize,
}) => {
  const { appConfig } = useContext(AppContext);
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const [searchFormRef] = Form.useForm();

  const tableColumns = [
    {
      title: "#",
      key: "index",
      render: (text, record, index) => {
        return <>{index + 1}</>;
      },
    },
    {
      title: t("amount"),
      render: (subscription) => {
        return (
          <>
            <CurrencyFormatter value={subscription.amount} />
          </>
        );
      },
    },
    {
      title: t("date"),
      dataIndex: "created_at",
      render: (created_at) => {
        return created_at ? moment(created_at).format("MMM. D, YYYY") : "-";
      },
    },
    {
      title: t("name"),
      render: (subscription) => {
        return <>{subscription.user.name}</>;
      },
    },
    {
      title: t("type"),
      dataIndex: "deduction_type",
      render: (deduction_type) => {
        return (
          <>
            {deduction_type === BALANCE_DEDUCTION_TYPE_SUBSCRIPTION &&
              "subscription"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_QRORDER && "Qr Order"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_TABLEMANAGEMENT &&
              "Table Management"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_ORDERMANAGEMENT &&
              "Order Management"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_WAITERMANAGEMENT &&
              "Waiter Management"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_JOBMANAGEMENT &&
              "Job Management"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_STOCKMANAGEMENT &&
              "Stock Management"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_SUREPAY && "Surepay"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_CUSTOMERSMANAGEMENT &&
              "Customer Management"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_SALESINVOICE &&
              "A4 Sales Invoice"}
            {deduction_type === BALANCE_DEDUCTION_TYPE_TICKETING && "Ticketing"}
          </>
        );
      },
    },
  ];

  const handleSearch = (values) => {
    let search_params = false;
    if (values.dates) {
      let startDateUtc = moment.utc(values.dates[0]).set({
        date: values.dates[0].date() - 1,
        month: values.dates[0].month(),
        year: values.dates[0].year(),
        hour: 19,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      let endDateUtc = moment.utc(values.dates[1]).set({
        date: values.dates[1].date(),
        month: values.dates[1].month(),
        year: values.dates[1].year(),
        hour: 18,
        minute: 59,
        second: 59,
        millisecond: 0,
      });

      search_params = {
        from_date: startDateUtc.format(),
        to_date: endDateUtc.format(),
      };
    }
    if (values.deduction_type) {
      search_params = {
        deduction_type: values.deduction_type,
        ...search_params,
      };
    }

    if (search_params) {
      setSearchParams(search_params);
    } else {
      setSearchParams([]);
    }
  };

  const handleReset = () => {
    // Reset Form Fields
    searchFormRef.resetFields();
    // Reset Transactions List
    setSearchParams([]);
  };

  const searchForm = (
    <>
      <Form
        name="search-form"
        layout="inline"
        onFinish={handleSearch}
        form={searchFormRef}
      >
        <Form.Item name="dates" label={t("date_range")}>
          <RangePicker allowClear format="DD/MM/YYYY" />
        </Form.Item>
        <Form.Item name="deduction_type" label={t("type")}>
          <Select
            allowClear
            style={{ width: "200px" }}
            options={deduction_types.map((type) => {
              return {
                label: type.text,
                value: type.id,
              };
            })}
          />
        </Form.Item>

        <Form.Item>
          <Input
            type="submit"
            value={t("search")}
            style={{
              backgroundColor: "#6301f2",
              color: "#ffffff",
              width: "80px",
            }}
          />
        </Form.Item>
        <Form.Item>
          <Input type="button" value={t("reset")} onClick={handleReset} />
        </Form.Item>
      </Form>
    </>
  );

  const handleTableChange = (pagination) => {
    setPaginationData(pagination);
    setCurrentPage(pagination.current);
    setPerPageSize(pagination.pageSize);
  };

  return (
    <>
      <Card
        style={{
          direction: appConfig.direction
            ? appConfig.direction === "ltr"
              ? "ltr"
              : "rtl"
            : "ltr",
        }}
      >
        {searchForm}
      </Card>
      <Card>
        <Table
          columns={tableColumns}
          dataSource={balanceDeductionsHistory}
          rowKey="id"
          pagination={{
            current: paginationData.current_page,
            pageSize: paginationData.per_page,
            total: paginationData.total,
            showSizeChanger: true,
          }}
          onChange={handleTableChange}
        />
      </Card>
    </>
  );
};

export default TransactionsTable;
